import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {listingPagesView_template} from  "../components/templates/listingPagesView_template";

declare var ko: any;
declare var page: any;

export class listing_page_view extends vnModule_knockoutJS {

    protected listingpageView: listingPagesView_template;
    protected XHRHdl: XMLHttpRequestHandler;

    buildContent(): Array<Element> {
        this.listingpageView = new listingPagesView_template("listing_page_view_template", this.viewModel, this);
        return [this.listingpageView.build()];
    }

    protected getModuleName(): string {
        return "listing_page_view";
    }

    fillPage() {
        this.getListingPageDataForView()
    }

    private getListingPageDataForView() {

        this.loadingIn(this.listingpageView.builtTemplate);

        let url : string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/config/listing-pages/get/' + this.getVnAppZone().app.params.id + '/';
        let request_parameters : Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(url, request_parameters, this);
        this.XHRHdl.onReadyStateFunction = this.onGetListingPageDataForView;
        this.XHRHdl.execute();
    }

    private onGetListingPageDataForView(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);

                obj.listingpageView.setListingPageData(responseParsed);
                obj.listingpageView.setIdBrand(obj.getVnAppZone().app.params.idBrand);
                obj.loadingOut(obj.listingpageView.builtTemplate);
            });


        }
    }

    public viewOnWebsite(permalink: string) {

        let idBrand = this.getVnAppZone().app.params.idBrand;
        let userBrands = this.getVnAppZone().app.loggedUser.user.brands;
        let url = window.location.hostname.split(".");
        let urlBegin = "https://";
        let isLocal = false;

        if ( url.length == 3 ) { // Not on live

            if ( url[0] != "emakicms") { // Either on qa, staging or ads
                urlBegin += url[0]+".";
            } else {
                isLocal = true;
            }
        }

        for (let i=0; i< userBrands.length; i++) {
            if (userBrands[i].id == idBrand) {

                window.open(urlBegin + userBrands[i].domain.replace("www.", "") + ( isLocal ? ( "." +url[2] ) : "" ) + permalink, "_blank")
                break;
            }
        }
    }

    protected onClickEditListingPage(id){
        let brandId = this.getVnAppZone().app.params.idBrand
        page("/brand/" + brandId + "/config/listing-pages/edit/" + id + '/')
    }

    protected onClickCancel(){
        let brandId = this.getVnAppZone().app.params.idBrand
        page.redirect("/brand/" + brandId + "/config/listing-pages/")
    }

}


// WEBPACK FOOTER //
// ./js/modules/listing_page_view.ts